import React, { useRef, useState } from 'react'

import {
    TextInputContainer,
    TextInputArea,
    SendButton,
    ChatFooterContainer,
    SendButtonImg,
} from './styles'

const ChatFooter = ({ onSendMsg }) => {
    const [commentText, setCommentText] = useState('')
    const textInput = useRef(null)

    const onChangeInput = event => {
        const text = event.target.value
        setCommentText(text)
    }

    const onSendClicked = () => {
        handleKeyUp(null)
        submitComment()
    }

    const submitComment = () => {
        const trimmedText = commentText.trim()
        if (trimmedText) {
            onSendMsg(trimmedText)
            setCommentText('')
        }
    }

    const handleKeyUp = e => {
        setTimeout(() => {
            if (textInput.current) {
                textInput.current.style.height = '1px'

                textInput.current.style.height =
                    Math.min(textInput.current.scrollHeight, 140) + 'px'
                textInput.current.scrollTop = textInput.current.scrollHeight
            }
        }, 0)
    }

    return (
        <ChatFooterContainer>
            <TextInputContainer>
                <TextInputArea
                    ref={textInput}
                    placeholder="Say something"
                    value={commentText}
                    onChange={onChangeInput}
                    onKeyUp={handleKeyUp}
                />
                <SendButton onClick={onSendClicked}>
                    <SendButtonImg src="assets/send.svg" />
                </SendButton>
            </TextInputContainer>
        </ChatFooterContainer>
    )
}

export default React.memo(ChatFooter)
